import React from "react";
import { Link } from "react-router-dom";
import NavItem from "../../../components/navigation/NavItem";
import FilterDropupMenu from "./navigation/FilterDropupMenu";

// layout
import { Footer } from "../../../layout/Footer";

// icons
import { ListFilter, CircleUserRound, ScrollText } from "lucide-react";

const ViewsFooter = ({ activeFilters, onToggleFilter }) => {
  return (
    <Footer
      className="app-footer fixed-bottom"
      size="md"
      start={
        <div className="w-33 d-flex flex-column align-items-center">
          <NavItem icon={<ListFilter size={32} />}>
            <FilterDropupMenu
              activeFilters={activeFilters}
              onToggleFilter={onToggleFilter}
            />
          </NavItem>
          {/* <NavItem icon={<ListFilter size={32} />}>
            <FilterDropupMenu />
          </NavItem> */}
        </div>
      }
      center={
        <div className="w-33 d-flex flex-column align-items-center">
          <Link key="list" to="/tale/list" aria-label="List of Tales">
            <ScrollText size={32} />
          </Link>
        </div>
      }
      end={
        <div className="w-33 d-flex flex-column align-items-center">
          <Link key="user" to="#" aria-label="User Profile">
            <CircleUserRound size={32} />
          </Link>
        </div>
      }
    />
  );
};

export default ViewsFooter;
